module.exports = __webpack_public_path__ + "img/crane_dribbble.320bb147.gif";